<template>
  <td v-if="version === 'table'">{{ price }}</td>
  <div v-else-if="version === 'print'" class="price text-left">{{ price }}</div>
  <div v-else-if="version === 'standard'" class="price">{{ price }}</div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    lead: Object,
    config: Object,
    currency: Object,
    version: String,
    hidingConfig: Object,
    currencyDict: Object,
  },
  computed: {
    price() {
      /* TODO сделать константу */
      const byQuery = 'По запросу'
      const priceField = this.lead.custom_fields_values?.find(
        (cf) => cf.field_id === this.config.price,
      )
      if (!priceField) return byQuery
      const priceValue = parseInt(priceField.values[0].value)
        .toLocaleString()
        .split(',')
        .join(' ')
      const from = this.config.priceFrom ? 'от ' : ''

      const measures = this.hidingConfig?.measures || []
      const currencyDict = this.currencyDict || {}
      const candidateValuteField = measures.find((m) => {
        return (
          m.type === 'valute' &&
          m.fieldId === this.config.price &&
          currencyDict[m.measure]
        )
      })
      if (candidateValuteField) {
        const symbol = currencyDict[candidateValuteField.measure].symbol_native
        return `${from}${priceValue} ${symbol}`
      }

      return `${from}${priceValue} ${this.currency.symbol_native}`
    },
  },
}
</script>

<style scoped>
.text-left {
  text-align: left !important;
}
</style>
